import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addBlog } from 'slice/blogSlice';
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';

const mdParser = new MarkdownIt();

const AddBlog = () => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: null,
    });

    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.blog);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, type, value, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleEditorChange = ({ text }) => {
    setFormData((prev) => ({
        ...prev,
        description: text,
    }));
};
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        try {
            await dispatch(addBlog(formDataToSend));
            toast.success("Blog added successfully!");
            navigate("/blog");
            setFormData({ title: '', description: '', image: null });
        } catch (error) {
            console.error("Blog creation failed:", error.message);
            toast.error("Failed to add blog.");
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Blog</h4>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="row mx-4">
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="title" className="adminlables">Title</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-sm-12 mt-4">
                        <label htmlFor="description" className="adminlables">Description (Markdown)</label>
                        <MdEditor
                            value={formData.description}
                            style={{ height: '300px' }}
                            renderHTML={(text) => mdParser.render(text)}
                            onChange={handleEditorChange}
                        />
                    </div>

                    <div className="col-sm-12 mt-4">
                        <label htmlFor="image" className="adminlables">Image</label>
                        <input
                            type="file"
                            id="image"
                            name="image"
                            className="form-control btn-block filebg"
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="mt-5 text-right mx-4">
                    <button className="btn btn-lg addbtn" disabled={loading}>Add Blog</button>
                </div>
            </form>
        </div>
    );
};

export default AddBlog;
